import Report from '@/models/Report'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    reportDetails: null,
  },

  mutations: {
    setReportList(state, reports) {
      each(reports, (report) => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new Report(report))
        }
      })
    },

    clearReportList(state) {
      state.list = []
    },

    setReportListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportDetails(state, report) {
      if (report instanceof Report) {
        state.reportDetails = report
      } else {
        state.reportDetails = new Report(report)
      }
    },

    clearReportDetails(state) {
      state.reportDetails = null
    },

    setSelectedCategoryAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.categoryDetails.avatar = avatar
      } else {
        state.categoryDetails.avatar = new Avatar(avatar)
      }
    },

    categoryAvatarRemoved(state) {
      state.userDetails.avatar = null
    },
  },

  actions: {
    async getReports({ commit }, params) {
      const query = Report.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort_direction) {
        query.params({ sort_direction: params.sort_direction })
      }

      let loadPrams = {
        limit: 1,
        sort_direction: params.sort_direction,
        sort_by: params.sort_by,
      }

      if (params.limit) {
        loadPrams.limit = params.limit
      }

      const res = await query.params(loadPrams).get()

      commit('clearReportList')
      commit('setReportList', res.data)
      commit('setReportListMeta', res.meta)
    },

    async getReportDetails({ commit }, id) {
      const { data } = await Api.get(`admin/reports/${id}`)
      commit('setReportDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedCategoryAvatar', data.data)
    },

    async updateReport({ commit }, form) {
      const { data } = await Api.put(`admin/reports/${form.id}`, form)
      commit('setCategoryDetails', data.data)
    },

    async createReport({ commit }, form) {
      let formData = new FormData()

      if (form.name) {
        formData.append('name', form.name)
      }

      if (form.name) {
        formData.append('brand', form.brand)
      }

      if (form.description) {
        formData.append('description', form.description)
      }

      if (form.price_per_day) {
        formData.append('price_per_day', form.price_per_day)
      }

      if (form.parent_category_id) {
        formData.append('parent_category_id', form.parent_category_id)
      }

      if (form.sub_category_id) {
        formData.append('sub_category_id', form.sub_category_id)
      }

      if (form.condition_id) {
        formData.append('condition_id', form.condition_id)
      }

      if (form.delivery_method_id) {
        formData.append('delivery_method_ids[]', form.delivery_method_id)
      }

      if (form.owner_id) {
        formData.append('owner_id', form.owner_id)
      }

      if (form.line) {
        formData.append('line', form.line)
      }

      if (form.city) {
        formData.append('city', form.city)
      }

      if (form.state) {
        formData.append('state', form.state)
      }

      if (form.postal_code) {
        formData.append('postal_code', form.postal_code)
      }

      if (form.country) {
        formData.append('country', form.country)
      }

      if (form.latitude) {
        formData.append('latitude', form.latitude)
      }

      if (form.longitude) {
        formData.append('longitude', form.longitude)
      }

      if (form.images) {
        form.images.forEach((image) => {
          formData.append('images[]', image)
        })
      }

      const { data } = await Api.post(`admin/reports`, formData)
      commit('setCategoryDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/users/export', { responseType: 'blob' })
      return file
    },
  },
}
